export * from './safe-html';



// WEBPACK FOOTER //
// ./src/app/pipes/index.ts